<template>
    <v-row justify="center">
        <v-img
            v-for="(preview, idx) in previewImages"
            :key="idx"
            @click="$emit('click', idx)"
            :src="preview"
            max-width="300"
            class="ma-1 elevation-1"
        ></v-img>
    </v-row>
</template>

<script>
export default {
    props: ['image'],

    data() {
        return {
            previewImages: [],
        }
    },

    watch: {
        image(to) {
            this.previewImages.forEach(image => {
                URL.revokeObjectURL(image)
            })

            if (to instanceof Blob) {
                this.previewImages = [ URL.createObjectURL(to) ]
            } else if (to instanceof String) {
                this.previewImages = [ to ]
            } else if (to instanceof Array && to.length > 0) {
                this.previewImages = []

                to.forEach(image => {
                    if (image instanceof Blob) {
                        this.previewImages.push(URL.createObjectURL(image))
                    } else {
                        this.previewImages.push(image)
                    }
                })
            } else {
                this.previewImages = []
            }
        }
    },
}
</script>
